"use client"

import React from "react";
import Message from "components/Message"
import ValuePropIntro from "../ValuePropIntro";

const RotatedCardList = (props) => {
    const {messages: cardData, vpConfig: config} = props

    const scrollRef = React.useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({left: direction * 320, behavior: 'smooth'});
        }
    };


    const colors = config.colors || ['rgb(255,216,158)', 'rgb(220,231,208)']
    const processedCardData = cardData.map((card, index) => {
        card.bgColor = index % 2 ? colors[0] : colors[1];
        card.rotation = index % 2 ? '-3deg' : '3deg'
        return card
    })

    return (
        <div className="row">
            <ValuePropIntro {...props} />

            <div className="position-relative w-100 py-5 px-4">
                <button
                    className="position-absolute top-50 start-0 translate-middle-y btn btn-light shadow"
                    onClick={() => scroll(-1)}
                    style={{zIndex: 10}}
                >
                    &lt;
                </button>

                <div
                    className="py-4"
                    style={{
                        overflowX: 'auto',
                        overflowY: 'visible',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        scrollSnapType: 'x mandatory'
                    }}
                    ref={scrollRef}
                >
                    <ul className="list-unstyled d-flex gap-4 m-0 p-0" style={{width: 'max-content'}}>
                        {processedCardData.map((card, index) => (
                            <li
                                key={index}
                                className="shadow rounded position-relative flex-shrink-0 d-flex flex-column justify-content-between"
                                style={{
                                    width: 300,
                                    height: 400,
                                    backgroundColor: card.bgColor,
                                    padding: '1.25rem',
                                    transform: `rotate(${card.rotation})`,
                                    scrollSnapAlign: 'center',
                                    marginLeft: index === 0 ? '1rem' : '0',
                                    marginRight: '1rem'

                                }}
                            >
                                <h5 className="mt-0 fs-5 text-dark text-center"><Message>{card.title}</Message></h5>
                                <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                                    <img src={card.image.url} alt={card.image.alt} className="img-fluid"
                                         style={{maxWidth: '70%'}}/>
                                </div>
                                <p className="small text-dark mb-0">{card.description}</p>
                            </li>
                        ))}
                    </ul>
                </div>

                <button
                    className="position-absolute top-50 end-0 translate-middle-y btn btn-light shadow"
                    onClick={() => scroll(1)}
                    style={{zIndex: 10}}
                >
                    &gt;
                </button>

                <style>{`
        div::-webkit-scrollbar {
          display: none;
        }
        div {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
            </div>
        </div>
    );
};

export default RotatedCardList;
